// 🔧 vendor_repository.js
// ✅ Purpose: Firestore repository for Vendor Engine demo data
// ✅ Features:
// - Writes vendor documents
// - Uses the production Firestore structure
// - Uses Firestore-generated document IDs
// - No business logic
// - No data generation
// - Repository pattern only
// - Fully block-commented for clarity and future devs

import {
  collection,
  doc,
  writeBatch,
  serverTimestamp,
} from "firebase/firestore";

import { db } from "../../../firebase";

export const saveVendors = async ({
  demoContext,
  vendors = [],
} = {}) => {
  console.log("💾 Saving Vendor Engine demo data.");

  const eventId =
    demoContext?.eventId ||
    demoContext?.eventResult?.eventId ||
    demoContext?.event?.eventId;

  if (!eventId) {
    throw new Error(
      "Vendor Repository requires an eventId."
    );
  }

  if (vendors.length === 0) {
    return {
      vendors: [],
    };
  }

  const batch = writeBatch(db);

  vendors.forEach((vendor) => {
    const vendorRef = doc(
      collection(
        db,
        "events",
        eventId,
        "vendors"
      )
    );

    batch.set(vendorRef, {
      ...vendor,

      eventId,

      createdAt: serverTimestamp(),
      updatedAt: serverTimestamp(),

      demoSeed: true,
    });
  });

  await batch.commit();

  console.log("✅ Vendor Engine repository completed.", {
    vendors: vendors.length,
  });

  return {
    vendors,
  };
};